export const stats: [string, string][] = [
  ['8', 'VOLUMI'],
  ['480+', 'PAGINE'],
  ['64', 'UNITÀ'],
  ['100%', 'SODDISFAZIONE'],
]
